import { BookOpen, BrainCircuit, Calculator, ChartNoAxesCombined, Code2, HeartHandshake, type LucideIcon } from 'lucide-react'
import type { WorkspaceCode } from '../model/workspaceCatalog'

const icons: Record<WorkspaceCode, LucideIcon> = {
  english: BookOpen,
  math: Calculator,
  programming: Code2,
  iq: BrainCircuit,
  eq: HeartHandshake,
  finance: ChartNoAxesCombined,
}

export function WorkspaceIcon({ code, className }: { code: WorkspaceCode; className?: string }) {
  const Icon = icons[code]
  return <Icon className={className} />
}
